module.exports = __webpack_public_path__ + "img/3.4bbcbf45.svg";